/* =========================================================================
   Free + True - quick add on product cards and curated PDP rituals

   Adds one product, or a curated group of complementary products, without
   leaving the page. The theme's existing cart drawer is refreshed and opened
   after a successful add.

   Prices are deliberately left to Shopify and the B2B app. Multi-variant
   products never guess a variant; Liquid renders those as product links.
   ========================================================================= */

(function () {
  'use strict';

  if (window.ftQuickAddLoaded) return;
  window.ftQuickAddLoaded = true;

  var ADD_URL = '/cart/add.js';
  var RESET_AFTER = 2400;

  function ancestorWithAttr(node, attr) {
    while (node && node !== document) {
      if (node.nodeType === 1 && node.getAttribute && node.getAttribute(attr) !== null) return node;
      node = node.parentNode;
    }
    return null;
  }

  function ancestorWithClass(node, cls) {
    var needle = ' ' + cls + ' ';
    while (node && node !== document) {
      if (node.nodeType === 1 && (' ' + (node.className || '') + ' ').indexOf(needle) > -1) return node;
      node = node.parentNode;
    }
    return null;
  }

  function label(btn, text) {
    var el = btn.querySelector('[data-ft-qa-label]');
    (el || btn).textContent = text;
  }

  function say(btn, message, isError) {
    var wrap = ancestorWithClass(btn, 'ft-qa');
    var el = wrap && wrap.querySelector('[data-ft-qa-status]');
    if (!el) return;
    el.textContent = message || '';
    el.className = 'ft-qa__status'
      + (message ? ' ft-qa__status--filled' : '')
      + (isError ? ' ft-qa__status--error' : '');
  }

  function attr(btn, name, fallback) {
    var value = btn.getAttribute(name);
    return (value === null || value === '') ? fallback : value;
  }

  function parseResponse(response) {
    return response.json().then(
      function (data) { return { ok: response.ok, data: data }; },
      function () { return { ok: response.ok, data: null }; }
    );
  }

  function addToCart(variantId, onDone, onFail) {
    var body = 'id=' + encodeURIComponent(variantId) + '&quantity=1';

    if (window.fetch) {
      window.fetch(ADD_URL, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: body
      }).then(parseResponse).then(function (result) {
        if (result.ok) onDone(result.data); else onFail(result.data);
      })['catch'](function () { onFail(null); });
      return;
    }

    var xhr = new XMLHttpRequest();
    xhr.open('POST', ADD_URL, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onload = function () {
      var data = null;
      try { data = JSON.parse(xhr.responseText); } catch (e) {}
      if (xhr.status >= 200 && xhr.status < 300) onDone(data); else onFail(data);
    };
    xhr.onerror = function () { onFail(null); };
    xhr.send(body);
  }

  function addItemsToCart(variantIds, onDone, onFail) {
    var items = [];
    for (var i = 0; i < variantIds.length; i++) {
      items.push({ id: variantIds[i], quantity: 1 });
    }
    var body = JSON.stringify({ items: items });

    if (window.fetch) {
      window.fetch(ADD_URL, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: body
      }).then(parseResponse).then(function (result) {
        if (result.ok) onDone(result.data); else onFail(result.data);
      })['catch'](function () { onFail(null); });
      return;
    }

    var xhr = new XMLHttpRequest();
    xhr.open('POST', ADD_URL, true);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onload = function () {
      var data = null;
      try { data = JSON.parse(xhr.responseText); } catch (e) {}
      if (xhr.status >= 200 && xhr.status < 300) onDone(data); else onFail(data);
    };
    xhr.onerror = function () { onFail(null); };
    xhr.send(body);
  }

  function refreshCart() {
    try {
      if (window.ajaxCart && typeof window.ajaxCart.load === 'function') {
        window.ajaxCart.load();
        return true;
      }
    } catch (e) {}
    return false;
  }

  function openDrawer() {
    try {
      if (window.timber && window.timber.RightDrawer && typeof window.timber.RightDrawer.open === 'function') {
        window.timber.RightDrawer.open();
        return true;
      }
    } catch (e) {}

    try {
      var $ = window.jQuery;
      if (!$ || typeof $._data !== 'function') return false;
      var toggles = document.querySelectorAll('.js-drawer-open-right');
      for (var i = 0; i < toggles.length; i++) {
        var events = $._data(toggles[i], 'events');
        if (events && events.click && events.click.length) {
          $(toggles[i]).trigger('click');
          return true;
        }
      }
    } catch (e) {}

    return false;
  }

  function track(eventName, details) {
    try {
      window.dataLayer = window.dataLayer || [];
      details = details || {};
      details.event = eventName;
      window.dataLayer.push(details);
    } catch (e) {
      /* A successful cart action must never depend on analytics. */
    }
  }

  function begin(btn) {
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    label(btn, attr(btn, 'data-ft-qa-label-busy', 'Adding…'));
    say(btn, '');
  }

  function finish(btn) {
    var restLabel = attr(btn, 'data-ft-qa-label-rest', 'Add to bag');
    label(btn, attr(btn, 'data-ft-qa-label-done', 'Added'));
    say(btn, attr(btn, 'data-ft-qa-msg-done', 'Added to your bag.'), false);
    refreshCart();
    openDrawer();

    window.setTimeout(function () {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      label(btn, restLabel);
    }, RESET_AFTER);
  }

  function fail(btn, data) {
    var message = (data && (data.description || data.message))
      || attr(btn, 'data-ft-qa-msg-fail', 'That could not be added just now. Open the product page to try again.');
    btn.removeAttribute('aria-busy');
    btn.disabled = false;
    label(btn, attr(btn, 'data-ft-qa-label-rest', 'Add to bag'));
    say(btn, message, true);
  }

  function onAddAll(event, btn) {
    event.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var ritual = ancestorWithClass(btn, 'ft-ritual');
    if (!ritual) return;

    var nodes = ritual.querySelectorAll('[data-ft-ritual-variant]');
    var ids = [];
    var seen = {};
    for (var i = 0; i < nodes.length; i++) {
      var id = nodes[i].getAttribute('data-ft-ritual-variant');
      if (id && !seen[id]) {
        seen[id] = true;
        ids.push(id);
      }
    }
    if (!ids.length) return;

    begin(btn);
    addItemsToCart(ids, function () {
      track('ft_pdp_ritual_add_all', {
        product: ritual.getAttribute('data-ft-product') || '',
        product_count: ids.length
      });
      finish(btn);
    }, function (data) {
      fail(btn, data);
    });
  }

  function onAddOne(event, btn) {
    event.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var variantId = btn.getAttribute('data-ft-qa-variant');
    if (!variantId) return;

    begin(btn);
    addToCart(variantId, function () {
      var ritual = ancestorWithClass(btn, 'ft-ritual');
      if (ritual) {
        track('ft_pdp_ritual_add_one', {
          product: ritual.getAttribute('data-ft-product') || '',
          variant_id: variantId
        });
      }
      finish(btn);
    }, function (data) {
      fail(btn, data);
    });
  }

  function onClick(event) {
    var addAll = ancestorWithAttr(event.target, 'data-ft-qa-add-all');
    if (addAll) {
      onAddAll(event, addAll);
      return;
    }

    var addOne = ancestorWithAttr(event.target, 'data-ft-qa-add');
    if (addOne) onAddOne(event, addOne);
  }

  document.addEventListener('click', onClick, false);
})();
